import createReducer, { createCollectionStatusReducer } from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';
import { Question } from '../interfaces/question';

type ListState = {
  [key: number]: Question[];
};

const list = createReducer<ListState>(
  {},
  {
    [ActionTypes.FETCH_QUESTIONS_SUCCESS]: (state, { payload }) =>
      Object.assign({}, state, { [payload.key]: payload.questions })
  }
);

const modal = createReducer(
  {},
  {
    [ActionTypes.FETCH_MODAL_QUESTIONS_SUCCESS]: (state, { payload }) => {
      return { [payload.key]: payload.questions, ...state };
    }
  }
);

const status = createCollectionStatusReducer(
  ActionTypes.FETCH_QUESTIONS_REQUEST,
  ActionTypes.FETCH_QUESTIONS_SUCCESS,
  ActionTypes.FETCH_QUESTIONS_NOT_FOUND,
  ActionTypes.FETCH_QUESTIONS_ERROR
);

export default combineReducers({
  list,
  status,
  modal
});
